export const name = 're-core-page-user-email-verification'
export const component = 're-email-verification'

import {factory} from '../../../../lib/page'

const props = {
  token: {},
  email: {},
}
export default factory(name, {props, component})
